import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300 border-t-4 border-purple-600">
      <div className="max-w-7xl mx-auto px-6 py-12">

        <div className="flex flex-col md:flex-row justify-between gap-12">

          {/* Brand Section (Left) */}
          <div className="md:w-1/3">
            <h3 className="text-2xl font-bold text-white mb-3 text-center">
              Mithil Peeris
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed text-center">
              Computer Science student passionate about AI, Machine Learning,
              and Full-Stack Development. Building scalable systems and
              meaningful products.
            </p>
          </div>

          {/* Centered Sections */}
          <div className="md:w-2/3 flex justify-center gap-20 text-center md:text-left">

            {/* Navigation */}
            <div>
              <h4 className="text-white font-semibold mb-4">Navigation</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-purple-400 transition">Home</Link></li>
                <li><Link to="/about" className="hover:text-purple-400 transition">About</Link></li>
                <li><Link to="/projects" className="hover:text-purple-400 transition">Projects</Link></li>
                <li><Link to="/contact" className="hover:text-purple-400 transition">Contact</Link></li>
              </ul>
            </div>

            {/* Featured Projects */}
            <div>
              <h4 className="text-white font-semibold mb-4">Featured Projects</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/projects/maplee" className="hover:text-purple-400 transition">
                    Maplee Marketplace
                  </Link>
                </li>
                <li>
                  <Link to="/projects/facial-recognition" className="hover:text-purple-400 transition">
                    Facial Recognition System
                  </Link>
                </li>
                <li>
                  <Link to="/projects/facebook-post-ml-analysis" className="hover:text-purple-400 transition">
                    Facebook ML Analysis
                  </Link>
                </li>
                <li>
                  <Link to="/projects/paper-trading" className="hover:text-purple-400 transition">
                    Paper Trading Engine
                  </Link>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-purple-400 text-center text-purple-400 py-4 text-xs">
        © {year} Mithil Peeris. All rights reserved.
      </div>
    </footer>
  );
}
